/* eslint-disable react/react-in-jsx-scope */
/* import BienvenidaCriterian from './bienvenida' */
import ImagenesEmpresa from './imagenes-empresa'
import Descripciones from '../../shared/descriptions/Descripciones'
import NuestraTecnologia from './nuestra-tecnologia'
import Invitacion from '../empresa/invitacion-criterian'
import fondoBanner from '../../../assets/images/empresa/Hero-section.png'
import React from 'react'
import constantes from '../../constantes/constantes'
import Banner from '../../shared/banners/banner'
import FraseDestacada from '../../shared/banners/fraseDestacada'
const valores = constantes.valores
const LaEmpresa = (): any => {
  return (
      <div className='w-full h-full flex flex-col justify-center items-center '>
        <div className='relative'>
          <div className='sticky top-0 pt-[0.1px]'>
            <Banner image={fondoBanner} title='Bienvenidos a Criterian' description='En el vertiginoso mundo del desarrollo de software, abrazamos la incertidumbre como una oportunidad para innovar. Cada proyecto es un desafío que aceptamos con valentía, sabiendo que en la complejidad encontramos nuestra fuerza. No nos detenemos ante lo desconocido; lo abrazamos y lo convertimos en nuestra ventaja.' subtituloResponsive></Banner>
          </div>
          <div className='sticky top-0 bg-white flex flex-col justify-center items-center'>
            <ImagenesEmpresa/>
            <Descripciones items={valores} titulo='Nuestros valores' subrayado='valores' blanco={false}/>
            <FraseDestacada textClassName='text-center md:!w-[70%] !w-[96%] !text-[16px] md:!text-[36px] ' texto='"En el equipo, como en la tecnología, la sinergia impulsa la innovación. Como Bill Gates dijo una vez: ‘ En este negocio, por cada persona increíble, debes tener una docena de personas increíbles trabajando juntas’. Así es como creamos la magia del éxito, con un equipo que sobresale en cada línea de código."'/>
            <NuestraTecnologia/>
            <Invitacion/>
          </div>
        </div>
      </div>
  )
}
export default LaEmpresa
